<template>
  <span>
    <span @click="()=>{this.visible=true}">
        <slot> </slot>
    </span>
    <el-dialog :visible.sync="visible" title="提现审核" width="100%" center @open="onOpen">
      <div :id="id" style="width: 100%;height: 1000px"></div>
    </el-dialog>
  </span>
</template>

<script>
export default {
  name: "member-relation",
  data() {
    return {
      loading: true,
      visible: false
    }
  },
  props: {
    id: {
      type: String,
      require: true
    },
  },
  methods: {
    onOpen() {
      let _this = this;
      const element = document.getElementById(_this.id);
      setTimeout(() => {
        let myChart = _this.$echarts.init(element);
        myChart.showLoading();
        _this.$common.my_ajax({
          url: 'memberRelation/findUserMemberRelation',
          data: {
            userId: _this.id
          },
          success: function (response) {
            // 绘制图表
            let categoriesArray = response.item.categoriesArray;
            let categories = [];
            categoriesArray.forEach((v, i) => {
              categories[i] = {
                name: v
              };
            })
            let option = {
              title: {
                text: '角色关系图',
                subtext: '角色关系图',
                top: 'top',
                left: 'right'
              },
              tooltip: {
                formatter: '{c}'
              },
              legend: [{
                data: categories.map(function (a) {
                  return a.name;
                })
              }],
              animationDuration: 1500,
              animationEasingUpdate: 'quinticInOut',
              series: [
                {
                  type: 'graph',
                  layout: 'force',
                  data: response.item.views,
                  links: response.item.links,
                  categories: categories,
                  roam: true,
                  label: {
                    show: true,
                    position: 'right',
                    formatter: '{b}'
                  },
                  lineStyle: {
                    color: 'source',
                    curveness: 0.3
                  },
                  emphasis: {
                    focus: 'adjacency',
                    lineStyle: {
                      width: 10
                    }
                  }
                }
              ],
            };
            myChart.setOption(option);
            myChart.hideLoading();
          },
          failure: () => {
            myChart.hideLoading();
          }
        });
      }, 1000)
    }
  }
}
</script>

<style scoped>

</style>